module.exports = __webpack_public_path__ + "assets/img/QuestMark.0667567d.svg";